export default __webpack_public_path__ + "9c302aa59587792324ce78132785771d.png";